





















































































import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Emit, Prop, Vue, Watch, Ref } from "vue-property-decorator";
@Component({
  components: { ValidationProvider, ValidationObserver },
})
export default class ShipmentConfirmDialog extends Vue {
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;
  @Prop({ default: false }) value: boolean;
  @Prop({ default: "" }) title: string;
  @Prop({ default: "" }) content: string;
  @Prop({ default: "" }) okText: string;
  @Prop({ default: "" }) cancelText: string;
  @Prop({ default: false }) confirm: boolean;
  @Prop({ default: true }) closeButton: boolean;

  remark = undefined;

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  @Emit()
  onShow() {
    return;
  }

  @Emit()
  onHide() {
    return;
  }

  @Watch("show")
  onShowWatch(val) {
    this.remark = undefined;
    if (val) {
      this.onShow();
    }
  }

  async onSubmit() {
    const valid = await this.observer.validate();
    if (!valid) {
      this.$util.goToErrorField(this.observer);
      return;
    }

    this.$emit('ok', this.remark);
  }
}
